import { Helmet } from 'react-helmet-async';

interface CollectionPageSchemaProps {
  name: string;
  description: string;
  url: string;
  image?: string;
}

export const CollectionPageSchema = ({
  name,
  description,
  url,
  image
}: CollectionPageSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": name,
    "description": description,
    "url": url,
    "image": image,
    "isPartOf": {
      "@type": "WebSite",
      "name": "Fortify",
      "url": "https://fortify.dev"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Fortify",
      "logo": {
        "@type": "ImageObject",
        "url": "https://fortify.dev/logo.png"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
